// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  title: 'Gerencie tua conta',
  titleApps: 'Acesse os aplicativos',
  clientApp: {
    text: 'Acessar chaves',
    title: 'Clique aqui para acessar tuas chaves',
  },
  clientAdmin: {
    text: 'Acessar módulo admin',
    title: 'Clique aqui para acessar o módulo administrativo',
  },
  clientWebJobs: {
    text: 'Relatório de emails',
    title: 'Clique aqui para acessar o relatório de emails enviados',
  },
  changeName: {
    text: 'Trocar nome',
    title: 'Clique aqui para trocar o nome utilizado pelo sistema',
  },
  changeEmail: {
    text: 'Trocar email',
    title: 'Clique aqui para trocar teu email',
  },
  changePassword: {
    text: 'Trocar senha',
    title: 'Clique aqui para trocar tua senha',
  },
  signOut: {
    text: 'Encerrar conexão',
    title: 'Clique aqui para encerrar com segurança tua conexão',
  },
} as ILanguage;
